// ----------------------------------------------------------------------------
// Snippet: Card Label
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

import 'snippets/_containers/accordion/accordion';
import './_cart-footer.scss';
var CART_FOOTER_SELECTOR = '.cart__footer.js-accordion';
var ACCORDION_ITEM_SELECTOR = '.js-accordion__item';
var ACCORDION_BUTTON_SELECTOR = '.js-accordion__button';
var ACCORDION_CONTENT_SELECTOR = '.js-accordion__content';
// Matches the `laptop` SCSS breakpoint ($container--laptop)
var DESKTOP_MEDIA_QUERY = '(min-width: 1080px)';
var OPEN_CLASS = 'is-open';
var isBreakpointListenerBound = false;
function setAccordionLinkTabIndex(content, tabIndex) {
  content.querySelectorAll('a').forEach(link => {
    link.setAttribute('tabindex', tabIndex);
  });
}
function setCartFooterAccordionState(cartFooter, isOpen) {
  var accordionItem = cartFooter.querySelector(ACCORDION_ITEM_SELECTOR);
  var accordionButton = cartFooter.querySelector(ACCORDION_BUTTON_SELECTOR);
  var accordionContent = cartFooter.querySelector(ACCORDION_CONTENT_SELECTOR);
  if (!accordionItem || !accordionButton || !accordionContent) return;
  accordionItem.classList.toggle(OPEN_CLASS, isOpen);
  accordionButton.classList.toggle(OPEN_CLASS, isOpen);
  accordionContent.classList.toggle(OPEN_CLASS, isOpen);
  accordionButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  accordionContent.hidden = !isOpen;
  accordionContent.style.height = isOpen ? 'auto' : '0';
  setAccordionLinkTabIndex(accordionContent, isOpen ? '0' : '-1');
}
function syncCartFooterAccordionState() {
  var isDesktop = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
  document.querySelectorAll(CART_FOOTER_SELECTOR).forEach(cartFooter => {
    setCartFooterAccordionState(cartFooter, false);
  });
}
function bindBreakpointListener() {
  if (isBreakpointListenerBound) return;
  var breakpointQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
  var syncOnBreakpointChange = () => {
    syncCartFooterAccordionState();
  };
  if (typeof breakpointQuery.addEventListener === 'function') {
    breakpointQuery.addEventListener('change', syncOnBreakpointChange);
  } else {
    breakpointQuery.addListener(syncOnBreakpointChange);
  }
  isBreakpointListenerBound = true;
}
function initCartFooterAccordion() {
  bindBreakpointListener();
  syncCartFooterAccordionState();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartFooterAccordion);
} else {
  initCartFooterAccordion();
}
window.addEventListener('load', initCartFooterAccordion);
document.addEventListener('shopify:section:load', initCartFooterAccordion);